import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CuttingCustomHole, CuttingFastenersSet, LegacyDialogsService, PositioningTypeEnum } from 'cloud-shared-lib';

import { ApiLinks } from '../../../cutting-panel-list/csl.api-links';
import { FastenerSessionStorageManager, FastenerType } from '../fastener-session-storage-manager.helper';
import { FastenersSchemaDialogComponent } from './fasteners-schema-dialog/fasteners-schema-dialog/fasteners-schema-dialog.component';

@Component({
  selector: 'csl-fasteners-set-list',
  templateUrl: './fasteners-set-list.component.html',
  styleUrls: ['./fasteners-set-list.component.scss'],
})
export class FastenersSetListComponent implements OnInit {
  lastSelectedId = 0;

  @Input() sets: CuttingFastenersSet[] = [];

  @Output() formChanged: EventEmitter<CuttingFastenersSet> = new EventEmitter();

  fastenersSchemaDialogRef: MatDialogRef<FastenersSchemaDialogComponent>;

  constructor(private dialogsService: LegacyDialogsService) {}

  ngOnInit(): void {
    const lastSelectedSS = FastenerSessionStorageManager.lastSelectedFastener;

    if (lastSelectedSS && lastSelectedSS.type === FastenerType.FastenerSet) {
      this.lastSelectedId = lastSelectedSS.id;
    }
  }

  selectSet(set: CuttingFastenersSet): void {
    this.formChanged.emit(set);
  }

  openFastenersSchemaDialog(holes: CuttingCustomHole[], positionType: PositioningTypeEnum): void {
    const dataDialog = { holes, positionType };

    this.dialogsService.open(FastenersSchemaDialogComponent, {
      data: dataDialog,
      width: '900px',
    });
  }
  getFastenersSetIconLink(fastenersSetId: number): string {
    return ApiLinks.fastenersSetIcon(fastenersSetId);
  }
}
